import React from "react";
import { ButtonListEditor } from "./EditButtonGroup";
import { NewIconSelector } from "../BuilderComponents/Preview/IconPreview";

const EditRvActionsListForPosition = ({
  editElementData,
  setEditElementData,
  elements,
  tableId,
  tableType,
  device,
  places
}) => {
  const handleEditElementData = (key, value) => {
    setEditElementData({ ...editElementData, [key]: value });
  };
  return (
    <div>
      <NewIconSelector onChange={(newIcon) => handleEditElementData("icon", newIcon)} icon={editElementData.icon} />
      <ButtonListEditor
        list={JSON.parse(JSON.stringify(editElementData?.actions || []))}
        onChange={(newActions) => handleEditElementData("actions", newActions)}
        places={places}
        device={device}
        elements={elements}
        tableId={tableId}
        tableType={tableType}
        positionClasses={true}
      />
    </div>
  );
};

export default EditRvActionsListForPosition;
